export default __webpack_public_path__ + "static/indialogo-5a2a59df84d6560ca1f608784d49abba.svg";